<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss">
*::-webkit-scrollbar {
  width: 8px; //表示垂直滚动条的宽度
  height: 8px; //表示水平滚动条的高度
}
/*正常情况下滑块的样式*/
*::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.05);
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
/*鼠标悬浮在该类指向的控件上时滑块的样式*/
*:hover::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
/*鼠标悬浮在滑块上时滑块的样式*/
*::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.4);
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
/*正常时候的主干部分*/
*::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.4);
  background-color: rgba(0, 0, 0, 0.01);
}
/*鼠标悬浮在滚动条上的主干部分*/
*::-webkit-scrollbar-track:hover {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.4);
  background-color: rgba(0, 0, 0, 0.01);
}
.cus-icon {
  cursor: pointer;
  background-image: url(./assets/images/icon.png);
}
#app {
  width: 100%;
  height: 100%;
  overflow-x: scroll;
}
#app::-webkit-scrollbar {
  display: none;
}

.over_moudle {
  display: flex;
  justify-content: center;
  padding: 20px 0 !important;
  flex-direction: column !important;
  align-items: center !important;
  margin: 0 !important;
  border: none !important;
  font-size: 12px !important;
  width: 100% !important;
  max-width: 100% !important;
}
.cursor_load {
  cursor: wait !important;
}
img {
  max-width: 100%;
}
.nav_load {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
}
</style>
<style src="./assets/css/global.scss" lang="scss"></style>
<script>
export default {
  name: "App"
};
</script>



// WEBPACK FOOTER //
// src/App.vue